import ReactLoading, { LoadingType } from "react-loading";
import { Button, ExtendedButtonProps } from "@mui/material";

export interface ButtonContainedProps extends Omit<ExtendedButtonProps, "variant"> {
	loading?: boolean;
	loadingType?: LoadingType;
	loadingWidth?: string | number;
	loadingHeight?: string | number;
}

export const ButtonContained = ({
	"data-useremunit": useRemUnit = "false",
	loading = false,
	loadingType = "balls",
	loadingWidth,
	loadingHeight,
	children,
	...props
}: ButtonContainedProps) => {
	return (
		<Button disableElevation variant="contained" data-useremunit={useRemUnit} {...props}>
			{loading ? (
				<ReactLoading
					type={loadingType}
					width={loadingWidth ? loadingWidth : useRemUnit === "true" ? "2.4rem" : "24px"}
					height={loadingHeight ? loadingHeight : useRemUnit === "true" ? "2.4rem" : "24px"}
					color="currentColor"
				/>
			) : (
				children
			)}
		</Button>
	);
};
